// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3FQd5","additionalInfo":"AgreementModal_additionalInfo__ME1xW"};